import { AnyAction } from 'redux';

import reducerRegistry from '@comeon/reducer-registry';
import { REDUCER_NAME } from './sportsbook-constants';
import configurationReducer, {
	loadConfiguration as configurationLoadConfiguration
} from './sportsbook-configuration-duck';
import betslipReducer from '~/components/sportsbook/lobby/features/betslip/ducks/index';
import openBetsReducer from './features/open-bets/open-bets-duck';
import cashoutReducer from './features/cashout/cashout-duck';
import betBuilderModalReducer from './features/bet-builder-modal/sportsbook-bet-builder-modal-duck';
import shareBetModalReducer from './features/share-bet-modal/sportsbook-share-bet-modal-duck';
import searchReducer from './features/search/sportsbook-search-duck';
import createSliceSelector from '../../../utils/create-slice-selector';
import apiReducer from './api/sportsbook-api-duck';
import eventSubscriptionReducer from './features/event-subscription/sportsbook-event-subscription-duck';
import locationVerificationReducer from './features/location-verification/sportsbook-location-verification-duck';
import sportradarWidgetReducer from './features/sportradar-widget/sportsbook-sportradar-widget-duck';

// Action creators
export const loadConfiguration = configurationLoadConfiguration;

// Reducer
const initialState = {
	configuration: <ReturnType<typeof configurationReducer> | undefined>undefined,
	betslip: <ReturnType<typeof betslipReducer> | undefined>undefined,
	openBets: <ReturnType<typeof openBetsReducer> | undefined>undefined,
	cashout: <ReturnType<typeof cashoutReducer> | undefined>undefined,
	betBuilderModal: <ReturnType<typeof betBuilderModalReducer> | undefined>undefined,
	shareBetModal: <ReturnType<typeof shareBetModalReducer> | undefined>undefined,
	search: <ReturnType<typeof searchReducer> | undefined>undefined,
	api: <ReturnType<typeof apiReducer> | undefined>undefined,
	eventSubscription: <ReturnType<typeof eventSubscriptionReducer> | undefined>undefined,
	locationVerification: <ReturnType<typeof locationVerificationReducer> | undefined>undefined,
	sportradarWidget: <ReturnType<typeof sportradarWidgetReducer> | undefined>undefined
};

const reducer = (fullState = initialState, action: AnyAction = { type: '' }) => {
	// Reduce all slices
	return {
		configuration: configurationReducer(fullState.configuration, action),
		betslip: betslipReducer(fullState.betslip, action),
		openBets: openBetsReducer(fullState.openBets, action),
		cashout: cashoutReducer(fullState.cashout, action),
		betBuilderModal: betBuilderModalReducer(fullState.betBuilderModal, action),
		shareBetModal: shareBetModalReducer(fullState.shareBetModal, action),
		search: searchReducer(fullState.search, action),
		api: apiReducer(fullState.api, action),
		eventSubscription: eventSubscriptionReducer(fullState.eventSubscription, action),
		locationVerification: locationVerificationReducer(fullState.locationVerification, action),
		sportradarWidget: sportradarWidgetReducer(fullState.sportradarWidget, action)
	};
};

export type State = ReturnType<typeof reducer>;

export const selectSportsbookState = createSliceSelector<State>(REDUCER_NAME);

reducerRegistry.register(REDUCER_NAME, reducer);

export default reducer;
